module.exports = __webpack_public_path__ + "static/media/diputados-favoritos.5b0952c3.png";